import type { ReactNode } from 'react';

export type StatusTone = 'neutral' | 'info' | 'warning' | 'success' | 'danger';

interface StatusIndicatorProps {
  readonly label: string;
  readonly tone: StatusTone;
  readonly icon?: ReactNode;
  readonly className?: string;
}

const CLASSES_POR_TOM: Record<StatusTone, string> = {
  neutral: 'border-border bg-muted text-muted-foreground',
  info: 'border-blue-300 bg-blue-100 text-blue-800 dark:border-blue-800 dark:bg-blue-950/60 dark:text-blue-300',
  warning: 'border-amber-300 bg-amber-100 text-amber-900 dark:border-amber-800 dark:bg-amber-950/60 dark:text-amber-300',
  success: 'border-emerald-300 bg-emerald-100 text-emerald-900 dark:border-emerald-800 dark:bg-emerald-950/60 dark:text-emerald-300',
  danger: 'border-destructive/40 bg-destructive/10 text-destructive',
};

/** Estado semântico sempre acompanhado por texto e, opcionalmente, ícone. */
export function StatusIndicator({ label, tone, icon, className }: StatusIndicatorProps) {
  return (
    <span className={`inline-flex items-center gap-1 rounded border px-2 py-0.5 text-xs font-medium ${CLASSES_POR_TOM[tone]} ${className ?? ''}`}>
      {icon}
      {label}
    </span>
  );
}
